import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=6bc3b4e4&scoped=true&"
import script from "./Wizard.vue?vue&type=script&lang=ts&"
export * from "./Wizard.vue?vue&type=script&lang=ts&"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=6bc3b4e4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc3b4e4",
  null
  
)

export default component.exports